import moment from "moment";
import { localize } from "src/l10n";
import { AttentionSourceType, IAttentionRow } from "./types";

/**
 * "fre 9 okt".
 *
 * Through moment, whose locale l10n keeps on the signed-in language. The native
 * toLocaleDateString follows the browser's locale instead, which showed Swedish
 * readers "Fri, Oct 9" on an English-language machine.
 */
export function formatDueDate(value: string): string {
    return moment(value).format("ddd D MMM");
}

/**
 * The deadline in words: "förföll mån 21 sep", "kvittera senast mån 28 sep",
 * "förfaller ons 30 sep". Empty for a row with no deadline, which is a real
 * case — an invitation has none.
 *
 * Composed here rather than sent by the server, which knows the facts but not
 * the wording, and shared so the row and the band never word it differently.
 */
export function describeDue(row: IAttentionRow): string {
    if (!row.dueAt) {
        return "";
    }

    const date = formatDueDate(row.dueAt);

    if (row.isOverdue) {
        return `${localize("ATTENTION_META_WAS_DUE")} ${date}`;
    }

    if (row.sourceType === AttentionSourceType.NewsAcknowledgement) {
        return `${localize("ATTENTION_META_ACKNOWLEDGE_BY")} ${date}`;
    }

    return `${localize("ATTENTION_META_DUE")} ${date}`;
}

/**
 * The one line the menu band shows: the most urgent thing, and how many others
 * are behind it. "Brandskydd 2026 förfaller i morgon · 2 till".
 */
export function describeSummary(rows: IAttentionRow[], count: number): string {
    if (rows.length === 0) {
        return "";
    }

    const parts = [rows[0].title];
    const due = describeDue(rows[0]);

    if (due) {
        parts.push(due);
    }

    const others = count - 1;

    if (others > 0) {
        return `${parts.join(" ")} · ${others} ${localize("ATTENTION_BAND_MORE")}`;
    }

    return parts.join(" ");
}
